import AskAssistantChat from './AskAssistantChat.vue';

export default AskAssistantChat;
